<template>
  <div id="bread-crumbs" class="flex gap-2">
    <InlineSvg icon="home" width="16" height="16" class="pointer" @click="isSidebarMinimized = !isSidebarMinimized" />

    <nav class="flex items-center">
      <VaBreadcrumbs>
        <VaBreadcrumbsItem
          :data-lang="'MetabolicLang.menu.home'"
          :label="t('MetabolicLang.menu.home')"
          :to="{ name: 'dashboard' }"
        />
        <VaBreadcrumbsItem v-for="item in items" :key="item.label" :label="item.label" :to="item.to || undefined" />
      </VaBreadcrumbs>
    </nav>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import { useGlobalStore } from '@/stores/global-store'

const { isSidebarMinimized, breadCrumbs } = storeToRefs(useGlobalStore())

const { t } = useI18n()

const items = computed(() => {
  return breadCrumbs.value
})
</script>

<style lang="scss" scoped>
.x-flip {
  transform: scaleX(-100%);
}
</style>
